export type DietTypeEntry = {
  name: string;
  id: number;
  machineName: string;
  selected: boolean;
};

export const Diet_Types: Record<number, DietTypeEntry> & { allIds: number[] } =
  {
    0: {
      name: "Non Specific",
      id: 0,
      machineName: "NonSpecific",
      selected: false,
    },
    1: {
      name: "Mediterranean",
      id: 1,
      machineName: "Mediterranean",
      selected: false,
    },
    2: {
      name: "Vegetarian",
      id: 2,
      machineName: "Vegetarian",
      selected: false,
    },
    3: {
      name: "Vegan",
      id: 3,
      machineName: "Vegan",
      selected: false,
    },
    4: {
      name: "Paleo",
      id: 4,
      machineName: "Paleo",
      selected: false,
    },
    5: {
      name: "Keto",
      id: 5,
      machineName: "Keto",
      selected: false,
    },
    6: {
      name: "Pescatarian",
      id: 6,
      machineName: "Pescatarian",
      selected: false,
    },
    7: {
      name: "Low-Carb",
      id: 7,
      machineName: "Low-Carb",
      selected: false,
    },
    8: {
      name: "Omnivore",
      id: 8,
      machineName: "Omnivore",
      selected: false,
    },
    9: {
      name: "Lacto-ovo Vegetarian",
      id: 9,
      machineName: "Lacto-ovo Vegetarian",
      selected: false,
    },
    10: {
      name: "Lacto Vegetarian",
      id: 10,
      machineName: "Lacto Vegetarian",
      selected: false,
    },
    11: {
      name: "Ovo-vegetarian",
      id: 11,
      machineName: "Ovo-vegetarian",
      selected: false,
    },
    12: {
      name: "Energy Booster",
      id: 12,
      machineName: "Energy Booster",
      selected: false,
    },
    13: {
      name: "High-Protein",
      id: 13,
      machineName: "High-Protein",
      selected: false,
    },
    14: {
      name: "Low-Cholesterol",
      id: 14,
      machineName: "Low-Cholesterol",
      selected: false,
    },
    15: {
      name: "Cholesterol Free",
      id: 15,
      machineName: "Cholesterol Free",
      selected: false,
    },
    16: {
      name: "Low Sugar",
      id: 16,
      machineName: "Low Sugar",
      selected: false,
    },
    17: {
      name: "Sugar Free",
      id: 17,
      machineName: "Sugar Free",
      selected: false,
    },
    18: {
      name: "Halal",
      id: 18,
      machineName: "Halal",
      selected: false,
    },
    19: {
      name: "Kosher",
      id: 19,
      machineName: "Kosher",
      selected: false,
    },
    20: {
      name: "Low Sodium",
      id: 20,
      machineName: "Low Sodium",
      selected: false,
    },
    21: {
      name: "Gluten Free",
      id: 21,
      machineName: "Gluten Free",
      selected: false,
    },
    22: {
      name: "Dairy Free",
      id: 22,
      machineName: "Dairy Free",
      selected: false,
    },
    23: {
      name: "Rich in Omega-3",
      id: 23,
      machineName: "Rich in Omega-3",
      selected: false,
    },
    24: {
      name: "Sodium Free",
      id: 24,
      machineName: "Sodium Free",
      selected: false,
    },
    allIds: [
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
      21, 22, 23, 24,
    ],
  };
